/* GladGirl mobile left drawer helpers (unpublished backup theme only) */
(function () {
  var MQ = window.matchMedia('(max-width: 1024px)');

  function menuEl() {
    return document.querySelector('#header .dropdown_container[data-dropdown="menu"]');
  }

  function menuIsVisible() {
    var el = menuEl();
    if (!el) return false;
    return window.getComputedStyle(el).display !== 'none';
  }

  function syncOpenClass() {
    var open = MQ.matches && menuIsVisible();
    document.body.classList.toggle('mobile-drawer-open', open);
    var overlay = document.querySelector('#header [data-mobile-drawer-overlay]');
    if (overlay) overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function closeDrawer() {
    document.body.classList.remove('is-active', 'mobile-drawer-open', 'blocked-scroll');
    document.querySelectorAll('.dropdown_link').forEach(function (a) {
      a.classList.remove('active_link');
    });
    document.querySelectorAll('.dropdown_container').forEach(function (d) {
      d.style.display = 'none';
    });
    document.querySelectorAll('.mobile_nav div').forEach(function (d) {
      d.classList.remove('open');
    });
    syncOpenClass();
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.mobile-drawer-close') || t.closest('[data-mobile-drawer-overlay]')) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
        return;
      }
      // After theme dropdown handlers run, sync open state
      setTimeout(syncOpenClass, 0);
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menuIsVisible()) {
      closeDrawer();
    }
  });

  if (MQ.addEventListener) {
    MQ.addEventListener('change', syncOpenClass);
  } else if (MQ.addListener) {
    MQ.addListener(syncOpenClass);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncOpenClass);
  } else {
    syncOpenClass();
  }
})();
